import axios from "@/config/axios";
export default {
    //准六大
    quasisixmajor_list: data => axios.post("/index.php/Home/index/quasisixmajor_list", data),

    //offer获得
    offer_count_list: data => axios.post("/index.php/Home/index/offer_count_list", data),

    //最新动态
    latestdevelopments_list: data => axios.post("/index.php/Home/index/latestdevelopments_list", data),

    //八大offer榜
    offer_list: data => axios.post("/index.php/Home/index/offer_list", data),

    //准六大offer榜
    offer_quasisixmajor: data => axios.post("/index.php/Home/index/offer_quasisixmajor", data),

    //其他offer榜
    other_offer: data => axios.post("/index.php/Home/index/other_offer", data),

    //2021 offer获得
    twentyone_offer_count_list: data => axios.post("/index.php/Home/index/twentyone_offer_count_list", data),

    //2021 八大offer榜
    twentyone_offer_list: data => axios.post("/index.php/Home/index/twentyone_offer_list", data),

    //2021 准六大offer榜
    twentyone_offer_quasisixmajor: data => axios.post("/index.php/Home/index/twentyone_offer_quasisixmajor", data),


    //2022 offer获得
    twentytwo_offer_count_list: data => axios.post("/index.php/Home/index/twentytwo_offer_count_list", data),

    //2022 八大神校
    twentytwo_offer_list: data => axios.post("/index.php/Home/index/twentytwo_offer_list", data),

    //2022 五大牛校
    twentytwo_fiveschool_list: data => axios.post("/index.php/Home/index/twentytwo_fiveschool_list", data),

    // all offer
    all_sixschool_list: data => axios.post("/index.php/Home/index/all_sixschool_list", data),

};